import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface Intrastat {
    id: number;
    code: string;
    internalDescription?: string;
    externalCode1?: string;
    externalCode2?: string;
    externalCode3?: string;
    externalDescription1?: string;
    externalDescription2?: string;
    externalDescription3?: string;
}

export async function getIntrastat(id: number): Promise<Intrastat> {
    return rms2Fetch<Intrastat>(`intrastats/${id}`);
}

// The old API used a single POST for create/update (id=0 means create).
// The new API splits them: POST for create, PUT for update.
export async function saveIntrastat(i: Intrastat): Promise<Intrastat> {
    if (i.id === 0) {
        return rms2Fetch<Intrastat>('intrastats', {
            method: 'POST',
            body: JSON.stringify(i),
        });
    }
    return rms2Fetch<Intrastat>(`intrastats/${i.id}`, {
        method: 'PUT',
        body: JSON.stringify(i),
    });
}

export async function deleteIntrastat(id: number): Promise<void> {
    await rms2Fetch<void>(`intrastats/${id}`, { method: 'DELETE' });
}
